import { getProtectedImage } from '@/utils/api/fetchAuthImage'

import * as aggr from '@/api-generator/aggr'

import type { Member } from '@/types/userManage'

/**
 * 將 IdentityInfoModel 轉換為 Member
 * @param item IdentityInfoModel 實例
 * @returns Member 實例
 */
export const transformIdentityToMember = (item: aggr.IdentityInfoModel): Member => ({
  value: item.userName ?? item.email ?? undefined,
  userName: item.userName ?? undefined,
  userUuid: item.userUuid ?? undefined,
  email: item.email ?? undefined,
  photoUrl: item.photoUrl ?? undefined,
  blobImg: undefined
})

/**
 * 載入成員的圖片
 * @param members 成員列表
 */
export const loadMemberImages = async (members: Member[]): Promise<void> => {
  await Promise.allSettled(
    members.map(async (member) => {
      if (member.photoUrl && !member.blobImg) {
        const blobImg = await getProtectedImage(member.photoUrl)
        if (blobImg) {
          member.blobImg = blobImg
        }
      }
    })
  )
}

/**
 * 載入單一成員的圖片
 * @param member 成員
 */
export const loadSingleMemberImage = async (member: Member): Promise<void> => {
  if (member.photoUrl && !member.blobImg) {
    const blobImg = await getProtectedImage(member.photoUrl)
    if (blobImg) {
      member.blobImg = blobImg
    }
  }
}
